import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmComponent } from '../Components/ErrorPopUp/ConfirmComponent';
import { ErrorPopUpComponent } from "../Components/ErrorPopUp/ErrorPopUpComponent";


@Injectable()
export class DialogService {

	constructor(private modalService: NgbModal) { }

	error(msg: string, error: string) {
		let modal: NgbModalRef = this.modalService.open(ErrorPopUpComponent);

		modal.componentInstance.errorBody = msg;
		modal.componentInstance.errorStack = error;
	}

	confirm(msg: string): Promise<boolean> {
		let modal: NgbModalRef = this.modalService.open(ConfirmComponent);
		modal.componentInstance.message = msg || 'Are you sure?';
		return modal.result;
	}

	message(msg: string, title: string): Promise<any> {
		let modal: NgbModalRef = this.modalService.open(ErrorPopUpComponent);

		if (title) {
			modal.componentInstance.errorTitle = title;
		}
		modal.componentInstance.errorBody = msg;
		return modal.result;
		
	}

}


